import React, { useState, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useFirebase } from 'react-redux-firebase'
import { fire_storage } from '../../store'

import { PrimaryButton } from '../../components/UI/PrimaryButton'
import { PhotoInput } from '../../components/UI/PhotoInput'
import { Loading } from '../../components/UI/Loading'

import { processNewPhoto } from '../../functions/processNewPhoto'
import { getFormatedData } from '../../functions/getFormatedData'

import {MainContainer as CreateCategoryContainer} from './styled_components'

export function CreateCategory({ go_back }) {

    const database = useFirebase().ref('products/categories')

    const [dataAcceptChangeAvailable, setDataAcceptChangeAvailable] = useState(false)
    const [defaultDataHasSet, setDefaultDataHasSet] = useState(false)
    const [loading, setLoading] = useState(false)

    const [parentCategory, setParentCategory] = useState('')
    const [categoryName, setCategoryName] = useState('')
    const [categoryPicture, setCategoryPicture] = useState('')

    const categories = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.categories))
    const products = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.products_list))
    const CategoryPictureInput = useMemo(() => <PhotoInput picture={categoryPicture} setPicture={setCategoryPicture} />, [categoryPicture])

    function checkDataAcceptChangeAvailable() {
        const formatted_category_name = categoryName.trim().replace(/\s{2,}/g, ' ').toLowerCase()
        const name_not_empty_and_doesnt_match_with_other = (formatted_category_name.length !== 0) && (categories.filter(category => category.category_name.toLowerCase() === formatted_category_name).length === 0)
        const parent_category_doesnt_contain_products = products.filter( product => product.category === parentCategory ).length === 0

        if ( name_not_empty_and_doesnt_match_with_other && parent_category_doesnt_contain_products ) {
            setDataAcceptChangeAvailable(true)
        } else {
            setDataAcceptChangeAvailable(false)
        }

    }
    function setDefaultData () {
        setParentCategory('')
        setCategoryName('')
        setCategoryPicture('')

        setDefaultDataHasSet(true)
    }

    function handleSubmit() {
        const formatted_category_name = categoryName.trim().replace(/\s{2,}/g, ' ')

        setLoading(true)
 
        function push_data_to_database(picture_data) {
            const data = {
                category_name: formatted_category_name,
                category_picture: picture_data,
                parent_category_name: parentCategory
            }
            database.push(data)

            alert('Категория добавлена!')
            setDefaultDataHasSet(false)
        }

        if (categoryPicture) {
            const ref = fire_storage.ref(`img/products/categories/`)

            async function processPhotos() {
                setLoading(true)

                try {                      
                    const picture_data = await processNewPhoto( ref, categoryPicture)
                    push_data_to_database(picture_data)
                } catch { 
                    return
                } finally {
                    setLoading(false)
                }
                
            }
            processPhotos()
        } else {
            push_data_to_database([''])
            setLoading(false)
        }        
    }

    useEffect(() => {
        if (!defaultDataHasSet) {
            setDefaultData()
        }
        checkDataAcceptChangeAvailable()
    })

    return (
        <CreateCategoryContainer>
            <div className="inputs">

                {CategoryPictureInput}

                <p className='input-description'>Родительская категория</p>
                <select className='select' value={parentCategory} onChange={(e) => setParentCategory(e.target.value)} >
                    <option style={{ fontStyle: 'italic' }} value=''> Новый корневой каталог </option>
                    { categories
                        ? categories.map( (category, key)=> <option value={category.category_name} key={key}>{category.category_name}</option> )
                        : null
                    }
                </select>

                <p className='input-description'>Название новой категории (не должно совпадать с уже существующими)</p>
                <input className='input' placeholder='Название категории' type="text" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} />

            </div>

            { loading
                ? <Loading lighten />
                : dataAcceptChangeAvailable
                    ? <PrimaryButton onClick={() => handleSubmit()} lighten className='submit-button' >Добавить категорию</PrimaryButton>
                    : null
            }

            <p className='link-button' onClick={() => go_back('')} >Назад</p>
        </CreateCategoryContainer>
    )
}